
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building/[sid]/map",
      function () {
        return require("private-next-pages/building/[sid]/map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building/[sid]/map"])
      });
    }
  